export default __webpack_public_path__ + "static/media/comment-grey.4ad73e47.svg";